<script>

    import Vue from 'vue';
    import DefaultServerTable from '../../Libraries/ServerTable/DefaultServerTable';

    export default {

        extends:DefaultServerTable,

        methods: {
            addAdditionalFilter() {
                Vue.set(this.$refs.serverTable.filters, "inactive", {
                    name:"Oud-collega's",
                    id:"inactiveofficeusers",
                    enabled:false,
                    onChange:() => {
                        this.$refs.serverTable.resetData();
                    },
                });
            },
        },

        mounted() {
            this.addAdditionalFilter();
        }

    }

</script>
